import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  constructor() { }

  isProd(): boolean {
    return environment.rollbarEnv === 'prod';
  }

  isSandbox(): boolean {
    return environment.rollbarEnv === 'sandbox';
  }

  isDev(): boolean {
    return environment.rollbarEnv === 'dev';
  }

  isLocal(): boolean {
    return environment.rollbarEnv === 'local';
  }
}
